import styled from "styled-components";
import JobInfo from "./jobinfo";
import EmploymentDetails from "./employmentdetails";
import Compensation from "./compensation";

const Wrapper = styled.div`
    font-size: 13px;
`;

const Job = ({ person, refreshEmployeeInfo, disabled }: any) => {

    return (
        <Wrapper>
            <div className='row'>
                <div className='col-md-6' style={{ paddingRight: '7.5px' }}>
                    <JobInfo person={person} refreshEmployeeInfo={refreshEmployeeInfo} disabled={disabled} />
                </div>
                <div className='col-md-6' style={{ paddingLeft: '7.5px' }}>
                    <EmploymentDetails person={person} refreshEmployeeInfo={refreshEmployeeInfo} disabled={disabled} />
                </div>
                <div className='col-md-12'>
                    <Compensation person={person} disabled={disabled} />
                </div>
            </div>
        </Wrapper>
    );
};

export default Job;
